export function uncapitalize(s: string) {
  return s.charAt(0).toLowerCase() + s.slice(1);
}
export function capitalize(s: string) {
  return s.charAt(0).toUpperCase() + s.slice(1);
}

export function escapeHtmlAttr(s: string) {
  return s.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
